
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.072 4.849H4.929A1.929 1.929 0 003 6.777v10.286c0 1.065.863 1.929 1.929 1.929H7.21l-.35 3.143a.643.643 0 001.07.549l4.102-3.692h7.039A1.928 1.928 0 0021 17.063V6.777a1.929 1.929 0 00-1.928-1.928z","fill":"#000"}}),_c('rect',{attrs:{"x":"16.605","y":"9.172","width":"1.671","height":"9.209","rx":".835","transform":"rotate(90 16.605 9.172)","fill":"#fff"}}),_c('rect',{attrs:{"x":"13.171","y":"12.566","width":"1.671","height":"5.776","rx":".835","transform":"rotate(90 13.171 12.566)","fill":"#fff"}})])
          )
        }
      }
    